<template>
    <div class="rule Center">
      <div class="ruleBox">
        <img src="../assets/rule.png" alt="">
        <div class="close" @click="$emit('close')">
          <img src="../assets/btn/close.png" alt="">
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "rule"
}
</script>

<style scoped>
  .rule{width: 100%; height: 100%; background: rgba(0,0,0,0.7); position: absolute; top:0; z-index: 10;}
  .rule .ruleBox{width: 90%; position: relative;}
  .rule .ruleBox img{width: 100%;}
  .rule .close{position: absolute; bottom: -5%; text-align: center; width: 100%}
  .rule .close img{ width: 12%}
</style>



// WEBPACK FOOTER //
// src/components/rule.vue